class VivacProductEnhancements {
  constructor() {
    this.stickyBar = document.querySelector('[data-vivac-sticky-buy]');
    this.stickyPrice = this.stickyBar?.querySelector('[data-vivac-sticky-price]');
    this.stickyButton = this.stickyBar?.querySelector('[data-vivac-sticky-submit]');
    this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    this.primaryButton = null;
    this.priceSource = null;
    this.priceObserver = null;
    this.buttonObserver = null;
    this.scrollFrame = null;

    if (!this.stickyBar || !this.productInfo) return;

    this.initDescription();
    this.connectProductControls();
    this.stickyButton.addEventListener('click', () => this.submitMainForm());
    window.addEventListener('scroll', () => this.requestVisibilityUpdate(), { passive: true });
    window.addEventListener('resize', () => this.requestVisibilityUpdate(), { passive: true });
    document.addEventListener('shopify:section:load', () => this.refresh());
    document.addEventListener('product-info:loaded', () => this.refresh());
    this.requestVisibilityUpdate();
  }

  initDescription() {
    const description = this.productInfo.querySelector('.product__description');
    if (!description || description.dataset.vivacReady === 'true') return;

    description.dataset.vivacReady = 'true';
    description.classList.add('vivac-description');

    requestAnimationFrame(() => {
      const collapsedHeight = window.matchMedia('(max-width: 749px)').matches ? 150 : 180;
      if (description.scrollHeight <= collapsedHeight + 24) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vivac-description-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = this.stickyBar.dataset.showMore;
      description.id = description.id || 'VivacProductDescription';
      button.setAttribute('aria-controls', description.id);
      description.classList.add('is-collapsed');
      description.insertAdjacentElement('afterend', button);

      button.addEventListener('click', () => {
        const willExpand = description.classList.contains('is-collapsed');
        description.classList.toggle('is-collapsed', !willExpand);
        button.setAttribute('aria-expanded', String(willExpand));
        button.textContent = willExpand
          ? this.stickyBar.dataset.showLess
          : this.stickyBar.dataset.showMore;
      });
    });
  }

  connectProductControls() {
    this.productInfo = document.querySelector('product-info[id^="MainProduct-"]') || this.productInfo;
    this.primaryButton = this.productInfo.querySelector(
      'product-form form[action*="/cart/add"] .product-form__submit'
    );
    this.priceSource = this.productInfo.querySelector('[id^="price-"]');

    this.priceObserver?.disconnect();
    this.buttonObserver?.disconnect();

    if (this.priceSource) {
      this.syncPrice();
      this.priceObserver = new MutationObserver(() => this.syncPrice());
      this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
    }

    if (this.primaryButton) {
      this.syncButton();
      this.buttonObserver = new MutationObserver(() => this.syncButton());
      this.buttonObserver.observe(this.primaryButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  syncPrice() {
    if (!this.priceSource || !this.stickyPrice) return;
    this.stickyPrice.innerHTML = this.priceSource.innerHTML;
    this.stickyPrice.querySelectorAll('.badge').forEach((badge) => badge.remove());
  }

  syncButton() {
    if (!this.primaryButton || !this.stickyButton) return;
    const isDisabled =
      this.primaryButton.disabled ||
      this.primaryButton.getAttribute('aria-disabled') === 'true';
    this.stickyButton.disabled = isDisabled;
    this.stickyButton.setAttribute('aria-disabled', String(isDisabled));
    this.stickyButton.classList.toggle('is-loading', this.primaryButton.classList.contains('loading'));

    const sourceLabel = this.primaryButton.querySelector('span:not(.sold-out-message)');
    const stickyLabel = this.stickyButton.querySelector('span');
    if (sourceLabel?.textContent.trim() && stickyLabel) {
      stickyLabel.textContent = sourceLabel.textContent.trim();
    }
  }

  submitMainForm() {
    if (!this.primaryButton || this.stickyButton.disabled) return;
    this.primaryButton.click();
  }

  requestVisibilityUpdate() {
    if (this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    if (!this.primaryButton) return;
    const buttonRect = this.primaryButton.getBoundingClientRect();
    const shouldShow = buttonRect.bottom < 0;
    this.stickyBar.classList.toggle('is-visible', shouldShow);
    this.stickyBar.setAttribute('aria-hidden', String(!shouldShow));
    document.body.classList.toggle('vivac-sticky-buy-visible', shouldShow);
  }

  refresh() {
    requestAnimationFrame(() => {
      this.initDescription();
      this.connectProductControls();
      this.requestVisibilityUpdate();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('product-info[id^="MainProduct-"]')) {
    window.vivacProductEnhancements = new VivacProductEnhancements();
  }
});
